import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`meet | educate | incubate`}</h1>
    <p>{`The African Hub to increase Ethereum awareness and create Ethereum based solutions to solve everyday challenges.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      